<script>
	import { loading } from "../../store/store";

	import Loader from "./Loader.svelte";

	let loader;
	loading.subscribe((value) => {
		loader = value;
	});
</script>

{#if loader}
	<Loader />
{:else}
	<slot />
{/if}
